<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Anamnesi Farmacologica" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <span v-if="isReadOnly">{{ jsonDataAnamnesiFarmacologica.voce }}</span>
                            <b-form-textarea v-else v-model="jsonDataAnamnesiFarmacologica.voce" :readonly="isReadOnly" max-rows="10" rows="8"> </b-form-textarea>
                        </b-col>

                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!isReadOnly && jsonDataAnamnesiFarmacologica.id" @click="onSaveAnamnesiFarmacologica"  variant="outline-success">Salva</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataAnamnesiFarmacologica: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataAnamnesiFarmacologica: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaAnamnesiFarmacologica: "/rsaschedarelazionesanitariaanamnesifarmacologica",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaAnamnesiFarmacologica() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaAnamnesiFarmacologica + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaAnamnesiFarmacologicaSuccess, me.resultResponseSchedaRelazioneSanitariaAnamnesiFamiliareError);
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiFarmacologicaSuccess(response) {
            let me = this;
            me.jsonDataAnamnesiFarmacologica = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiFarmacologicaError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataAnamnesiFarmacologica = {
                id: null,
                idAccettazione: me.idAccettazione,
                voce: null,
            };
        },

        onSaveAnamnesiFarmacologica() {
            let me = this;
            me.jsonDataAnamnesiFarmacologica.idAccettazione = me.idAccettazione;
            if (!me.jsonDataAnamnesiFarmacologica.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaAnamnesiFarmacologica, me.jsonDataAnamnesiFarmacologica, me.saveSchedaRelazioneSanitariaAnamnesiFarmacologicaSuccessResponse, me.saveSchedaRelazioneSanitariaFarmacologicaErrorResponse);
        },
        saveSchedaRelazioneSanitariaAnamnesiFarmacologicaSuccessResponse() {
            let me = this;
            me.$bvToast.toast("Anamnesi farmacologica salvata con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$parent.loadData();
        },
        saveSchedaRelazioneSanitariaAnamnesiFarmacologicaErrorResponse() {
            console.error("Errore nel salvataggio dell'anamnesi farmacologica:");
        },
    },
};
</script>
